// import {useNavigation} from '@react-navigation/native';
// import Toast from 'react-native-toast-message';
import { useToast } from "@chakra-ui/react";
import { useMutation, useQueryClient } from "react-query";
import { useNavigate } from "react-router-dom";
import { startReading } from "../../services/readingOrdersApi";
import { trackEvent } from "../analytics";

/**
 *
 * @param {*} noRedirect if true will redirect to reading list / if false to reading order
 */
export default function useStartReadingOrder(noRedirect = false) {
  const queryClient = useQueryClient();
  const toast = useToast();
  const navigate = useNavigate();
  const mutation = useMutation(({ readingOrderId }) => {
    return startReading(readingOrderId);
  });

  const startReadingOrder = (readingOrderId, franchiseTab = 0) => {
    mutation
      .mutateAsync({ readingOrderId })
      .then(({ data }) => {
        trackEvent("reading_order_started", {
          reading_order_id: readingOrderId,
          reading_order_title: data?.data?.readingOrder?.title,
          reading_id: data?.data?.id,
          source_path: window.location.pathname,
        });
        queryClient.invalidateQueries("readings");
        queryClient.invalidateQueries("paywall");
        if (noRedirect) {
          toast({
            title: "New reading added",
            description: `${data.data.readingOrder.title} was added to your Reading list.`,
            status: "success",
            duration: 5000,
            isClosable: true,
          });
          navigate("/reading", { state: { franchiseTab } });
        } else {
          navigate(`/reading/${data.data.id}`);
        }
      })
      .catch((err) => {
        toast({
          title: "Unable to start reading order",
          description: err?.response?.data?.message || "Please try again.",
          status: "warning",
          duration: 6000,
          isClosable: true,
        });
      });
  };

  return { startReadingOrder, isLoading: mutation.isLoading };
}
